<template>
  <div class="ad-content-panel">
    <div class="content-layout">
      <div class="upload-col">
        <a-upload
          list-type="picture-card"
          class="ad-uploader"
          :class="uploaderClass"
          :show-upload-list="false"
          :accept="acceptTypes"
          :disabled="uploading"
          :before-upload="beforeUpload"
        >
          <div v-if="value.imageUrl" class="preview-wrap">
            <img :src="value.imageUrl" alt="广告图">
          </div>
          <div v-else class="upload-placeholder">
            <a-icon :type="uploading ? 'loading' : 'plus'" />
            <div class="ant-upload-text">{{ uploading ? '上传中' : '上传' }}</div>
            <div class="ext-tip">支持扩展名: .webp .gif .png .jpg...</div>
          </div>
        </a-upload>
        <div v-if="sizeTip" class="size-tip">推荐尺寸{{ sizeTip }}</div>
      </div>

      <div class="form-col">
        <a-form-model
          :model="value"
          :label-col="{ span: 6 }"
          :wrapper-col="{ span: 16 }"
        >
          <a-form-model-item label="跳转方式">
            <a-radio-group :value="value.jumpType" @change="onJumpTypeChange">
              <a-radio
                v-for="item in jumpTypeOptions"
                :key="item.value"
                :value="item.value"
              >
                {{ item.label }}
              </a-radio>
            </a-radio-group>
          </a-form-model-item>

          <a-form-model-item v-if="value.jumpType === 'product'" label="关联商品">
            <div class="product-relate-row">
              <a-select
                :value="value.productRelateType"
                style="width: 160px"
                @change="onProductRelateTypeChange"
              >
                <a-select-option :value="1">关联单个商品</a-select-option>
                <a-select-option :value="2">关联商品分组</a-select-option>
              </a-select>
              <a-button @click="onOpenRelateSelect">选择</a-button>
            </div>
            <div v-if="value.targetName" class="product-selected">
              已选：{{ value.targetName }}（ID: {{ value.targetId }}）
            </div>
            <div v-else class="product-tip">
              {{ Number(value.productRelateType) === 2 ? '请关联商品分组' : '请关联产品' }}
            </div>
          </a-form-model-item>

          <a-form-model-item v-else-if="value.jumpType === 'activity'" label="选择活动">
            <a-select
              :value="value.targetId"
              placeholder="请选择"
              allow-clear
              show-search
              option-filter-prop="children"
              :loading="activityLoading"
              style="width: 100%"
              @change="onActivityChange"
              @focus="loadActivityOptions"
            >
              <a-select-option
                v-for="item in activityOptions"
                :key="item.value"
                :value="item.value"
              >
                {{ item.label }}
              </a-select-option>
            </a-select>
          </a-form-model-item>

          <a-form-model-item v-else-if="value.jumpType === 'link'" label="链接地址">
            <a-input
              :value="value.targetUrl"
              placeholder="请输入"
              allow-clear
              @change="e => patch({ targetUrl: e.target.value })"
            />
          </a-form-model-item>

          <a-form-model-item v-else-if="value.jumpType === 'miniProgram'" label="小程序路径">
            <a-input
              :value="value.targetUrl"
              placeholder="请输入"
              allow-clear
              @change="e => patch({ targetUrl: e.target.value })"
            />
          </a-form-model-item>

          <a-form-model-item v-if="showNotifyTitle" label="通知标题">
            <a-input
              :value="value.marketingTitle"
              placeholder="请输入"
              allow-clear
              @change="e => patch({ marketingTitle: e.target.value })"
            />
          </a-form-model-item>

          <a-form-model-item v-if="showBodyText" label="通知文本">
            <a-input
              :value="value.bodyText"
              placeholder="请输入"
              allow-clear
              @change="e => patch({ bodyText: e.target.value })"
            />
          </a-form-model-item>

          <a-form-model-item v-if="showPlaySeconds" label="播放时间">
            <a-input-number
              :value="value.playSeconds"
              :min="3"
              :max="15"
              placeholder="请输入3-15"
              style="width: 160px"
              @change="val => patch({ playSeconds: val })"
            />
            <span class="unit-text">秒</span>
          </a-form-model-item>

          <template v-if="showMarketingFields">
            <a-form-model-item v-if="showMarketingTitle" label="营销标题">
              <a-input
                :value="value.marketingTitle"
                placeholder="请输入"
                allow-clear
                @change="e => patch({ marketingTitle: e.target.value })"
              />
            </a-form-model-item>
            <a-form-model-item label="按钮文字">
              <a-input
                :value="value.buttonText"
                placeholder="如立即抢购"
                allow-clear
                @change="e => patch({ buttonText: e.target.value })"
              />
            </a-form-model-item>
          </template>
        </a-form-model>
      </div>
    </div>

    <selected-product-dialog
      :show="showProductDialog"
      :width="1000"
      :col="2"
      title="选择商品"
      :item-names="['search_keyword', 'search_proCatalog']"
      :query-params="productQueryParams"
      :request-promise="loadAdProductList"
      :columns="productColumns"
      row-key="proId"
      @close="showProductDialog = false"
    >
      <a-form-item
        slot="search_keyword"
        label="商品名称"
        v-bind="currentDialogLayout"
      >
        <a-input
          v-model="productQueryParams.keyword"
          allow-clear
          placeholder="请输入商品名称"
          style="width: 200px"
        />
      </a-form-item>
      <a-form-item
        slot="search_proCatalog"
        label="商品分类"
        v-bind="currentDialogLayout"
      >
        <a-select
          v-model="productQueryParams.proCatalogId"
          placeholder="请选择"
          allow-clear
          style="width: 200px"
        >
          <a-select-option
            v-for="item in proCatalogEnum"
            :key="item.value"
            :value="item.value"
          >
            {{ item.key }}
          </a-select-option>
        </a-select>
      </a-form-item>
      <template slot="action" slot-scope="rowItem">
        <a-button type="primary" @click="onProductSelect(rowItem.record)">选择</a-button>
      </template>
    </selected-product-dialog>

    <selected-product-dialog
      :show="showGroupDialog"
      title="选择商品分组"
      :width="1000"
      :col="2"
      :item-names="['search_groupName']"
      :query-params="selectedQueryGroupParams"
      :request-promise="getGroupRequest"
      :columns="getGroupColumns()"
      row-key="groupId"
      @close="showGroupDialog = false"
    >
      <a-form-item
        slot="search_groupName"
        label="商品分组名称"
        v-bind="currentDialogLayout"
      >
        <a-input
          v-model="selectedQueryGroupParams.groupName"
          allow-clear
          placeholder="请输入商品分组名称"
          style="width: 200px"
        />
      </a-form-item>
      <template slot="action" slot-scope="rowItem">
        <a-button type="primary" @click="onGroupSelect(rowItem.record)">选择</a-button>
      </template>
    </selected-product-dialog>
  </div>
</template>

<script>
import SelectedProductDialog from '@/customComponents/SelectedProductDialog/SelectedProductDialog.vue'
import productMixins from '@/utils/mixins/productMixins'

const SIZE_TIP_MAP = {
  1: '1080 × 1920 px',
  2: '960 × 540 px',
  3: '',
  4: '960 × 334 px'
}

const JUMP_TYPE_OPTIONS = [
  { label: '商品', value: 'product' },
  { label: '活动', value: 'activity' },
  { label: '链接', value: 'link' },
  { label: '小程序路径', value: 'miniProgram' }
]

export function createEmptyContent(adType) {
  return {
    adType,
    promotionId: undefined,
    imageUrl: '',
    jumpType: 'product',
    productRelateType: 1,
    targetId: undefined,
    targetName: '',
    targetUrl: '',
    bodyText: '',
    playSeconds: undefined,
    marketingTitle: '',
    buttonText: ''
  }
}

export default {
  name: 'AdvertisementContentPanel',
  components: {
    SelectedProductDialog
  },
  mixins: [productMixins],
  props: {
    adType: {
      type: Number,
      required: true
    },
    value: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      uploading: false,
      showProductDialog: false,
      showGroupDialog: false,
      acceptTypes: '.webp,.gif,.png,.jpg,.jpeg',
      jumpTypeOptions: JUMP_TYPE_OPTIONS,
      productQueryParams: {
        keyword: '',
        proCatalogId: undefined
      },
      selectedQueryGroupParams: {
        groupName: '',
        groupStatus: 1
      },
      productColumns: [
        { title: '商品ID', dataIndex: 'proId', width: '120px' },
        { title: '商品名称', dataIndex: 'title' },
        { title: '销量', dataIndex: 'salesCount', width: '100px' },
        {
          title: '操作',
          dataIndex: 'action',
          width: '120px',
          scopedSlots: { customRender: 'action' },
          fixed: 'right'
        }
      ],
      activityLoading: false,
      activityLoaded: false,
      activityOptions: []
    }
  },
  computed: {
    sizeTip() {
      return SIZE_TIP_MAP[this.adType] || ''
    },
    showPlaySeconds() {
      const adType = Number(this.adType)
      const jumpType = this.value.jumpType
      // 开屏：所有跳转方式都展示播放时间（含商品）
      if (adType === 1) {
        return true
      }
      // 大卡：链接、小程序路径展示播放时间
      if (adType === 4) {
        return jumpType === 'link' || jumpType === 'miniProgram'
      }
      return false
    },
    showNotifyTitle() {
      // 插屏：通知标题，入参 marketingTitle
      return Number(this.adType) === 2
    },
    showBodyText() {
      return Number(this.adType) === 2
    },
    showMarketingTitle() {
      // 小卡/大卡活动才展示「营销标题」；插屏已用「通知标题」占用 marketingTitle
      const adType = Number(this.adType)
      return (adType === 3 || adType === 4) && this.value.jumpType === 'activity'
    },
    showMarketingFields() {
      const adType = Number(this.adType)
      // 插屏/小卡/大卡：仅「活动」展示按钮文字（及小卡大卡的营销标题）
      if (adType === 2 || adType === 3 || adType === 4) {
        return this.value.jumpType === 'activity'
      }
      return false
    },
    uploaderClass() {
      const map = {
        1: 'uploader-portrait',
        2: 'uploader-landscape',
        3: 'uploader-banner-sm',
        4: 'uploader-banner-lg'
      }
      return map[this.adType] || 'uploader-landscape'
    }
  },
  methods: {
    patch(fields) {
      this.$emit('input', { ...this.value, ...fields })
    },
    onJumpTypeChange(e) {
      this.patch({
        jumpType: e.target.value,
        targetId: undefined,
        targetName: '',
        targetUrl: '',
        productRelateType: 1
      })
    },
    onProductRelateTypeChange(val) {
      this.patch({
        productRelateType: val,
        targetId: undefined,
        targetName: ''
      })
    },
    onOpenRelateSelect() {
      if (Number(this.value.productRelateType) === 2) {
        this.showGroupDialog = true
      } else {
        this.showProductDialog = true
      }
    },
    onGroupSelect(record) {
      if (!record) return
      this.patch({
        targetId: record.groupId,
        targetName: record.groupName || ''
      })
      this.showGroupDialog = false
    },
    onActivityChange(val) {
      const selected = this.activityOptions.find(item => item.value === val)
      this.patch({
        targetId: val,
        targetName: (selected && selected.label) || ''
      })
    },
    /**
     * POST /marketingActivity/page
     * 出参 data：{ totalCount, pageCount, data: [{ activityCode, activityTitle, ... }] }
     */
    loadActivityOptions() {
      if (this.activityLoading || this.activityLoaded) return
      this.activityLoading = true
      this.getHttpServices()
        .getNewServeService()
        .post('/marketingActivity/page', {
          activityTitle: '',
          beginDate: '',
          endDate: '',
          status: null,
          limitDto: { pageNum: 1, pageSize: 100 }
        })
        .then(res => {
          const list = (res && res.data) || []
          this.activityOptions = list.map(item => ({
            label: item.activityTitle || item.activityCode,
            value: item.activityCode
          }))
          this.activityLoaded = true
        })
        .catch(err => {
          this.$message.error((err && err.msg) || '加载活动失败')
        })
        .then(() => {
          this.activityLoading = false
        })
    },
    /**
     * POST /guanggao/product/list
     * SelectedProductDialog / SearchPageView 需要：{ totalCount, pageCount, data }
     */
    loadAdProductList(requestParams) {
      const { limitDto, keyword, proCatalogId } = requestParams || {}
      const pageNum = (limitDto && limitDto.pageNum) || 1
      const pageSize = (limitDto && limitDto.pageSize) || 10
      return this.getHttpServices()
        .getNewServeService()
        .post('/guanggao/product/list', {
          keyword: keyword || '',
          proCatalogId: proCatalogId || undefined,
          sortType: 1,
          sortOrder: 'DESC',
          pageNum,
          pageSize
        })
        .then(res => {
          const totalCount = (res && res.total) || 0
          const size = (res && res.pageSize) || pageSize
          return {
            totalCount,
            pageCount: size ? Math.ceil(totalCount / size) : 0,
            data: (res && res.records) || []
          }
        })
    },
    onProductSelect(record) {
      if (!record) return
      this.patch({
        targetId: record.proId,
        targetName: record.title || ''
      })
      this.showProductDialog = false
    },
    beforeUpload(file) {
      const isValid = /\.(webp|gif|png|jpe?g)$/i.test(file.name)
      if (!isValid) {
        this.$message.error('仅支持 .webp .gif .png .jpg 格式')
        return false
      }
      if (file.size / 1024 / 1024 > 5) {
        this.$message.error('图片大小不能超过 5MB')
        return false
      }
      this.uploadImage(file)
      return false
    },
    /**
     * POST /guanggao/image/upload
     * multipart/form-data：file
     * 出参 data：图片 url 字符串
     */
    uploadImage(file) {
      if (this.uploading) return
      const formData = new FormData()
      formData.append('file', file)
      this.uploading = true
      this.getHttpServices()
        .getNewServeService()
        .post('/guanggao/image/upload', formData, {
          'Content-Type': 'multipart/form-data'
        })
        .then(url => {
          this.patch({ imageUrl: url || '' })
          this.$message.success('上传成功')
        })
        .catch(err => {
          this.$message.error((err && err.msg) || '上传失败，请重试')
        })
        .then(() => {
          this.uploading = false
        })
    }
  }
}
</script>

<style scoped lang="less">
.ad-content-panel {
  .content-layout {
    display: flex;
    align-items: flex-start;
    gap: 48px;
    padding: 8px 0 24px;
  }

  .upload-col {
    flex-shrink: 0;
  }

  .form-col {
    flex: 1;
    min-width: 0;
    max-width: 560px;
  }

  .size-tip {
    margin-top: 8px;
    color: rgba(0, 0, 0, 0.45);
    font-size: 12px;
  }

  .ext-tip {
    margin-top: 4px;
    padding: 0 8px;
    color: rgba(0, 0, 0, 0.25);
    font-size: 12px;
    line-height: 1.4;
  }

  .unit-text {
    margin-left: 8px;
    color: rgba(0, 0, 0, 0.65);
  }

  .product-relate-row {
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .product-selected {
    margin-top: 6px;
    color: rgba(0, 0, 0, 0.65);
    font-size: 12px;
    line-height: 1.5;
  }

  .product-tip {
    margin-top: 6px;
    color: #f5222d;
    font-size: 12px;
    line-height: 1.5;
  }

  .preview-wrap {
    width: 100%;
    height: 100%;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }

  .ad-uploader {
    /deep/ .ant-upload.ant-upload-select-picture-card {
      width: 200px;
      height: 140px;
      margin: 0;
      background: #fafafa;
    }

    &.uploader-portrait /deep/ .ant-upload.ant-upload-select-picture-card {
      width: 160px;
      height: 280px;
    }

    &.uploader-landscape /deep/ .ant-upload.ant-upload-select-picture-card {
      width: 240px;
      height: 140px;
    }

    &.uploader-banner-sm /deep/ .ant-upload.ant-upload-select-picture-card {
      width: 220px;
      height: 120px;
    }

    &.uploader-banner-lg /deep/ .ant-upload.ant-upload-select-picture-card {
      width: 260px;
      height: 100px;
    }
  }
}
</style>
